import {
  PAYMENT_CREATE_REQUEST,
  PAYMENT_CREATE_SUCCESS,
  PAYMENT_CREATE_FAIL,

  PAYMENT_VERIFY_REQUEST,
  PAYMENT_VERIFY_SUCCESS,
  PAYMENT_VERIFY_FAIL,

  PAYMENT_RESET,
} from "../actions/paymentActions";


const initialState = {

  loading: false,

  razorpayOrder: null,

  paymentSuccess: false,

  paymentResult: null,

  error: null,

};


const paymentReducer = (
  state = initialState,
  action
) => {

  switch (action.type) {


    // =====================================================
    // RESET PAYMENT
    // =====================================================

    case PAYMENT_RESET:

      return {
        ...initialState,
      };


    // =====================================================
    // CREATE RAZORPAY ORDER - REQUEST
    // =====================================================

    case PAYMENT_CREATE_REQUEST:

      return {

        ...state,

        loading: true,

        paymentSuccess: false,

        paymentResult: null,

        error: null,

      };


    // =====================================================
    // CREATE RAZORPAY ORDER - SUCCESS
    // =====================================================

    case PAYMENT_CREATE_SUCCESS:

      return {

        ...state,

        loading: false,

        razorpayOrder:
          action.payload,

        error: null,

      };


    // =====================================================
    // CREATE RAZORPAY ORDER - FAIL
    // =====================================================

    case PAYMENT_CREATE_FAIL:

      return {

        ...state,

        loading: false,

        paymentSuccess: false,

        error:
          action.payload,

      };


    // =====================================================
    // VERIFY PAYMENT - REQUEST
    // =====================================================

    case PAYMENT_VERIFY_REQUEST:

      return {

        ...state,

        loading: true,

        paymentSuccess: false,

        error: null,

      };


    // =====================================================
    // VERIFY PAYMENT - SUCCESS
    // =====================================================

    case PAYMENT_VERIFY_SUCCESS:

      return {

        ...state,

        loading: false,

        paymentSuccess: true,

        paymentResult:
          action.payload,

        error: null,

      };


    // =====================================================
    // VERIFY PAYMENT - FAIL
    // =====================================================

    case PAYMENT_VERIFY_FAIL:

      return {

        ...state,

        loading: false,

        paymentSuccess: false,

        error:
          action.payload,

      };


    // =====================================================
    // DEFAULT
    // =====================================================

    default:

      return state;

  }

};


export default paymentReducer;